export default class FeatureFlags {
  static isP2PRestrictedToSameOrganization() {
    return process.env.PREACT_APP_WEBVIEW_FF_P2P_SAME_ORGANIZATION === 'true';
  }
}
